'use strict';

var status = {};

exports.__exports = status;
//# sourceMappingURL=status2.cjs.map
